import styled from "styled-components";
import theme from "../../styles/theme";
import Status from "../../types/enum/Status";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Modal from "../../components/Modal";
import { Icon } from "@mui/material";
import Card from "../../components/Card";
import { StyledText, TextSize, TextStatus } from "../../components/Text";
import { RightAlign } from "../../components/UtilsComponents";
import NormalIcon from "../../components/Icon";
import moment from "moment";

const SkillCompleted = styled(Card)`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  position: relative;
  width: auto;
  height: auto;
  min-height: 190px;
  left: 0px;
  top: 0px;

  /* Dark outline transparent */

  background: rgba(0, 0, 0, 0.3);
  // border: 2px solid #36eab9;
  // box-shadow: 0px 4px 35px #54c2ab;
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 10px;

  /* Inside auto layout */

  // flex: none;
  order: 0;
  // flex-grow: 0;
  // margin: 0px 20px;
  cursor: pointer;
`;
type EvaluationModalProps = {
  isOpen: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction?: () => void;
  credits: any;
  selectedRow: any;
  title?: string;
  isSnackbarOpen?: boolean;
  setIsSnackbarOpen?: any;
};
const Title = styled.div`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
`;
const StyledHr = styled.hr`
  width: 100%;
  border-color: #3c406c;
  margin-top: 16px;
  margin-bottom: 16px;
`;
const ViewDetailModal = ({
  isOpen,
  setOpen,
  // confirmFunction,
  title,
  credits,
  selectedRow,
  isSnackbarOpen,
  setIsSnackbarOpen,
}: EvaluationModalProps): JSX.Element => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Modal
        onDismiss={() => handleClose()}
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "99900" },
          content: {
            marginTop: 70,
            maxHeight: "90vh",
            maxWidth: "90vw",
            padding: "0 16px 24px 16px",
            background: "#090d20",
            boxShadow: "0 0 14px black",
          },
        }}
      >
        <FlexBox
          style={{ height: "64px", borderBottom: "1px solid #80808026" }}
        >
          <FlexGrow>
            <Title>
              {" "}
              <Icon
                sx={{
                  // color: "#ffff86",
                  mr: 1,
                  textShadow: "0 1px 5px black",
                }}
              >
                psychology
              </Icon>
              {title}
            </Title>
          </FlexGrow>
          <ClickableIcon name="times" onClick={() => handleClose()} />
        </FlexBox>
        <div
          className="visible-scrollbar"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 10,
            padding: "25px 10px",
            maxHeight: "70vh",
            overflow: "auto",
          }}
        >
          {selectedRow?.skills?.map((skill: any) => (
            <SkillCompleted
              style={{
                boxShadow: skill?.completed ? "0px 4px 35px #54c2ab30" : "",
                border: skill?.completed
                  ? "0.1px solid #36eab9"
                  : "1px solid #1d1c1c",
              }}
            >
              <FlexGrow style={{ width: "100%", flexGrow: 0 }}>
                <FlexBox style={{ width: "100%", alignItems: "start" }}>
                  <FlexGrow>
                    {skill?.required ? (
                      <StyledText
                        status={TextStatus.muted}
                        textSize={TextSize.default}
                        fontWeight="normal"
                      >
                        Required
                      </StyledText>
                    ) : (
                      <StyledText
                        status={TextStatus.muted}
                        textSize={TextSize.default}
                        fontWeight="normal"
                      >
                        Optional
                      </StyledText>
                    )}
                  </FlexGrow>
                  {skill?.completed && (
                    <RightAlign>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="600"
                        >
                          {"Completed"}
                          <NormalIcon
                            style={{ color: "#51bc55" }}
                            name="check"
                          />
                        </StyledText>
                        <FlexBox>
                          <StyledText
                            status={TextStatus.muted}
                            style={{ fontSize: "12px" }}
                            fontWeight="normal"
                          >
                            on{" "}
                            {moment(skill?.assessment?.assessment_time).format(
                              "YYYY-MM-DD"
                            )}
                          </StyledText>
                        </FlexBox>
                      </div>
                    </RightAlign>
                  )}
                </FlexBox>
                <StyledHr />
              </FlexGrow>
              <div style={{ width: "100%" }}>
                <div>
                  <StyledText textSize={TextSize.paragraph} fontWeight="700">
                    {skill.skill_code}
                  </StyledText>
                </div>
                <div>
                  <StyledText textSize={TextSize.paragraph} fontWeight="600">
                    {skill.title}
                  </StyledText>
                </div>
                <div>
                  <StyledText
                    status={TextStatus.muted}
                    style={{ fontSize: "12px" }}
                    fontWeight="normal"
                  >
                    {skill.description}
                  </StyledText>
                </div>

                <ul>
                  <li>
                    <div>
                      <StyledText
                        status={TextStatus.warning}
                        style={{ fontWeight: "bold" }}
                      >
                        {/* <span style={{ color: "orange" }}>Assessment :</span>{" "} */}
                        {skill?.assessment?.title}
                      </StyledText>
                    </div>
                    <StyledText status={TextStatus.muted}>
                      {skill?.assessment?.description}
                    </StyledText>
                  </li>
                  {skill?.topic_title && (
                    <li>
                      <div>
                        <StyledText
                          status={TextStatus.warning}
                          style={{ fontWeight: "bold" }}
                        >
                          <span style={{ color: "orange" }}>Topic :</span>{" "}
                          {skill?.topic_title}
                        </StyledText>
                      </div>
                      <StyledText status={TextStatus.muted}>
                        {skill?.topic_description}
                      </StyledText>
                    </li>
                  )}
                </ul>
              </div>
              {skill.assessment &&
                skill.assessment.assessment_time &&
                skill.assessment.assessment_time !== "" && (
                  <>
                    <FlexBox
                      style={{ borderTop: "1px solid white", marginTop: 15 }}
                    >
                      {/* <FlexGrow style={{ width: "100%", position:'absolute', bottom:10}}>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="600"
                        >
                          {moment(skill?.assessment?.assessment_time).format(
                            "YYYY-MM-DD"
                          )}
                        </StyledText>
                      </FlexGrow> */}
                      <div
                        style={{ position: "absolute", bottom: 10, right: 15 }}
                      >
                        {/* <RightAlign> */}
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="600"
                        >
                          Result: {skill?.assessment?.result}
                        </StyledText>
                        {/* </RightAlign> */}
                      </div>
                    </FlexBox>
                  </>
                )}
            </SkillCompleted>
          ))}
        </div>
        {/* <FlexBox justify="end" style={{ padding: "10px 0px" }}>
          <FlexBox>
            <Button
              style={{
                width: "151px",
                height: "38px",
                padding: "13px 12px",
              }}
              isOutline
              onClick={() => {
                // setOpen(false);
              }}
              status={Status.default}
            >
              Dismiss
            </Button>

        
          </FlexBox>
        </FlexBox> */}
      </Modal>
    </>
  );
};

export default ViewDetailModal;
